<template>
  <div class="signal-query-filter-component" style="display: inline-block;">
    <div v-if="filterUser" class="filter-option">
      <div style="display: flex;">
        <span style="margin-right: 5px;">Toon alleen eigen signalen</span>
        <a-switch :checked="filterQuery.user_id !== null" @change="filterByUser"/>
      </div>
    </div>

    <div v-if="filterDepartments" class="filter-option">
      <div style="display: flex">
        <span style="vertical-align:middle; line-height: 200%">Filter op afdeling&nbsp;</span>
        <a-select mode="multiple"
                  :disabled="disableFilters"
                  placeholder="Selecteer een afdeling"
                  v-model="filterQuery.department_ids" style="min-width: 240px"
                  @change="filterByDepartments">
          <a-select-option v-for="option in departments" :key="option.id" :value="option.id">
            {{ option.name }}
          </a-select-option>
        </a-select>
      </div>
    </div>

    <div v-if="filterRunWhen" class="filter-option">
      <div style="display: flex">
        <span style="vertical-align:middle; line-height: 200%">Filter op controlefrequentie&nbsp;</span>
        <a-select mode="multiple"
                  :disabled="disableFilters"
                  placeholder="Selecteer een frequentie"
                  v-model="filterQuery.run_when" style="min-width: 240px"
                  @change="filterByRunWhen">
          <a-select-option v-for="option in RunIntervalEnum" :key="option.key" :value="option">
            {{ translateRunInterval(option) }}
          </a-select-option>
        </a-select>
      </div>
    </div>

    <div class="filter-option">
      <div style="display: flex">
        <a-button :disabled="disableFilters" @click="resetFilter">Verwijder alle filters</a-button>
      </div>
    </div>
  </div>
</template>

<script>
import userDepartmentApi from '~/api/user_department';
import RunIntervalEnum from '~/enums/RunIntervalEnum';
import debounce from "lodash/debounce";

export default {
  name: 'SignalQueryFilterComponent',
  props: {
    userId: {
      type: [Number, String],
      required: false,
      default: null
    },
    disableFilters: {
      type: Boolean,
      default: false,
    },
    filterUser: {type: Boolean, default: false},
    filterDepartments: {type: Boolean, default: false},
    filterRunWhen: {type: Boolean, default: false},
  },
  data() {
    return {
      filterQuery: {
        user_id: null,
        department_ids: [],
        run_when: [],
      },

      departments: {},
      RunIntervalEnum,
    }
  },
  mounted() {
    if (this.filterByDepartments) {
      userDepartmentApi.index().then(response => {
        this.departments = response.data;
      })
    }
  },
  methods: {
    filterByUser(value) {
      this.filterQuery.user_id = value ? this.userId : null;
      this.filterRequest()
    },
    filterByDepartments() {
      this.filter(this);
    },
    filterByRunWhen() {
      this.filter(this);
    },

    filter: debounce((vm) => {
      vm.filterRequest()
    }, 700),

    filterRequest() {
      this.$emit('filter-query', this.filterQuery)
    },

    resetFilter() {
      this.filterQuery = {
        user_id: null,
        department_ids: [],
        run_when: [],
      }
      this.filterRequest();
    },

    translateRunInterval(interval) {
      switch (interval) {
        case RunIntervalEnum.NEVER:
          return "Niet uitvoeren";
        case RunIntervalEnum.DAILY:
          return "Dagelijks";
        case RunIntervalEnum.WEEKLY:
          return "Wekelijks";
        case RunIntervalEnum.MONTHLY:
          return "Maandelijks";
      }
    },
  },
  computed: {}
}
</script>

<style scoped>
.filter-option {
  display: inline-block;
  margin-left: 5px;
  /*height: 45px*/
}
</style>
